<template>
  <app-logged id="ReportMunicipioFilter">
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
        slim
      >
        <v-form>
          <app-widget
            actions
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <app-lista-relatorio
                class="mt-4"
                :event-name="event"
                :list="listOfFilters"
              />
              <AppFormHeader
                class="mt-4"
                title="Preencha os campos"
                icon="description"
              />
              <validation-provider
                name="cidade"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  label="Cidade/estado"
                  :items="cidades"
                  clearable
                  chips
                  v-model="variaveis.cidade"
                  :return-object="false"
                  :item-text="cidade"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                v-if="filter.period"
                name="início do período"
                v-slot="{ errors }"
              >
                <v-text-field
                  :disable="!filter.period"
                  type="month"
                  v-model="variaveis.inicial"
                  label="Início do período"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                v-if="filter.period"
                name="fim do período"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="month"
                  v-model="variaveis.final"
                  label="Fim do período"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div
              slot="widget-actions"
            >
              <v-spacer />
              <app-button
                :disable="invalid && !!filter"
                @click.native="goToRegiaoReport()"
              >
                gerar relatório
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
import AppListaRelatorio from '@/components/AppListaRelatorio'
import AppFormHeader from '@/components/AppFormHeader'
import ordenedReports from '@/util/report'
import { eventBus } from '@/main'
export default {
  name: 'ReportMunicipioFilter',
  components: {
    AppWidget,
    AppLogged,
    AppButton,
    ValidationProvider,
    ValidationObserver,
    AppFormHeader,
    AppListaRelatorio
  },
  data () {
    return {
      filter: {},
      event: 'REPORT_MUNICIPIO_GET_ROUTES'
    }
  },
  computed: {
    ...mapGetters(['cidades', 'variaveis']),
    listOfFilters: () => ordenedReports('municipios')
  },
  watch: {
    filter (val) {
      this.$refs.observer.reset()
      if (Object.entries(this.filter).length === 0) {
        return {}
      }
    }
  },
  created () {
    eventBus.$on(this.event, callback => {
      this.filter = callback
    })
  },
  methods: {
    cidade: item => `${item.nome}/${item.acronimo}`,
    goToRegiaoReport () {
      if (Object.entries(this.filter).length === 0) {
        return alert('É importante selecionar ao menos um filtro de relatório')
      }
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.$router.push({
            name: this.filter.route
          })
        }
      })
    }
  }
}
</script>
